export const commentData = {
	data() {
		return {
			headerList: [
				{
					prop: 'product_title',
					label: '课程标题',
					width: 160,
					tooltip: true
				},
				{
					prop: 'user',
					label: '用户',
                    width: 200
				},
				{
					prop: 'comment',
					label: '评论内容',
					width: 150,
					tooltip: true
				},
				{
					prop: 'score',
					label: '星级',
					width: 100
				},
				{
					prop: 'ty_name',
					label: '状态',
					width: 100
				},
				{
					prop: 'created_time',
					label: '创建时间'
				},
				{
					prop: 'come_from',
					label: '小程序'
				}
			]
		}
	}
}